import FilterForm from '../../../components/forms/FilterForm';
import { CrudFilters, HttpError, useCan } from '@refinedev/core';
import {
  DeleteButton,
  EditButton,
  ShowButton,
  TextField,
  useTable
} from '@refinedev/antd';
import { Form, Input, Space, Table } from 'antd';
import { IEcommerceProfitCenter } from 'interfaces/ecommerce_profit_centers';
import { ListLayout } from 'components/layout/layout/ListLayout';

interface IFilter {
  code: string;
}

export const EcommerceProfitCenterList = () => {
  const { data: canEdit } = useCan({
    resource: 'ecommerce_profit_centers',
    action: 'edit'
  });
  const { data: canDelete } = useCan({
    resource: 'ecommerce_profit_centers',
    action: 'delete'
  });

  const { tableProps, searchFormProps } = useTable<
    IEcommerceProfitCenter,
    HttpError,
    IFilter
  >({
    resource: 'ecommerce/profit_centers',

    onSearch: params => {
      const filters: CrudFilters = [];
      const { code } = params;

      filters.push({
        field: 'filter[code]',
        operator: 'eq',
        value: code
      });

      return filters;
    }
  });

  return (
    <ListLayout title="Centros de resultados">
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="code">
          <Input
            placeholder="Código do centro de custo"
            className="lg:min-w-[300px]"
          />
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="code"
          key="code"
          title="Código"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="description"
          key="description"
          title="Descrição"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex={['division', 'code']}
          key="division"
          title="Divisão"
          render={value => <TextField value={value} />}
        />
        <Table.Column<IEcommerceProfitCenter>
          title="Ações"
          dataIndex="actions"
          align="center"
          width={100}
          render={(_, record) => {
            return (
              <Space>
                <ShowButton hideText size="small" recordItemId={record.id} />
                {canEdit?.can && (
                  <EditButton hideText size="small" recordItemId={record.id} />
                )}
                {canDelete?.can && (
                  <DeleteButton
                    size="small"
                    resource="ecommerce/profit_centers"
                    recordItemId={record.id}
                    hideText
                  />
                )}
              </Space>
            );
          }}
        />
      </Table>
    </ListLayout>
  );
};
